import { isEmpty } from 'lodash/fp';
import { useTranslation } from 'react-i18next';
import { useGetAudiCalculationSettingsQuery } from '../../../api/queries/getAudiCalculationSettings';
import { ModuleType } from '../../../api/types';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NoItemResult from '../../../components/results/NoItemResult';
import NotFoundResult from '../../../components/results/NotFoundResult';
import AudiCalculationDetailsInnerPage from './AudiCalculationDetailsInnerPage';

const AudiCalculationDetailsPage = () => {
    const { t } = useTranslation(['audiCalculationDetails']);
    const company = useCompany(true);

    const { data, loading } = useGetAudiCalculationSettingsQuery({
        fetchPolicy: 'network-only',
        variables: { companyId: company?.id },
    });

    if (!company) {
        return <NoItemResult subTitle={t('audiCalculationDetails:noCompanySelected')} />;
    }

    if (loading) {
        return <LoadingElement />;
    }

    if (isEmpty(data?.modules)) {
        return <NotFoundResult />;
    }

    return <AudiCalculationDetailsInnerPage modules={data.modules} />;
};

export default AudiCalculationDetailsPage;
